import LoginError from './LoginError';
class InvalidLongitude extends LoginError {
    constructor(options) {
        super('Longitude provided by user is not valid', options);
    }
}
export default InvalidLongitude;
